<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" width="1100px" :before-close="() => {this.visible = false}">
      <div class="info" v-html="html" v-if="type == 1 || type == 2 || type == 3"></div>

      <!-- 积分充值 -->
      <div class="recharge" v-if="type == 5">
        <div class="balance">{{ $t('common.积分余额') }}：<span>{{userIntegral}}</span></div>
        <div class="type-list">
          <div class="item item-on" v-for="(item,key) in typeList" :key="key" @click="onTypeItem(item)">
            <img class="icon" src="~@/assets/common/19.png" v-if="item.id == typeId">
            <div class="tex">
              <span>{{item.integralNum}}</span>
              <span>{{ $t('common.积分') }}</span>
            </div>
            <div class="num">￥{{item.integralMoney}}</div>
          </div>
        </div>
        <div class="custom" @click="onCustom()">
          <img src="~@/assets/common/21.png" v-if="isCustom">
          <img src="~@/assets/common/20.png" v-else>
          <span>{{ $t('common.自定义充值') }}</span>
        </div>
        <div class="input" v-if="isCustom">
          <el-input v-model="integral" :placeholder="$t('common.请输入')"></el-input><span>{{ $t('common.积分') }}（10{{ $t('common.积分') }}=￥1）</span>
        </div>
        <div class="price">￥{{price}}</div>
        <div class="pay-list">
          <div class="item" @click="payType = 0">
            <img src="~@/assets/common/22.png">
            <div class="span">{{ $t('common.微信') }}{{ $t('common.支付') }}</div>
            <img src="~@/assets/common/21.png" v-if="payType == 0">
            <img src="~@/assets/common/20.png" v-else>
          </div>
          <div class="item" @click="payType = 1">
            <img src="~@/assets/common/23.png">
            <div class="span">{{ $t('common.支付宝') }}{{ $t('common.支付') }}</div>
            <img src="~@/assets/common/21.png" v-if="payType == 1">
            <img src="~@/assets/common/20.png" v-else>
          </div>
        </div>
        <div class="btn-list">
          <div class="btn" @click="submitJf()">{{ $t('common.立即充值') }}</div>
        </div>
      </div>

      <!-- 订阅 -->
      <div class="recharge" v-if="type == 6">
        <div class="type-list">
          <div class="item item-on" v-for="(item,key) in typeList2" :key="key" @click="typeId2 = item.id">
            <img class="icon" src="~@/assets/common/19.png" v-if="item.id == typeId2">
            <div class="tex">
              <span>￥{{item.subscriptionMoney}}</span>
              <span v-if="item.jsMoney > 0">￥{{item.jsMoney}}/{{ $t('common.月') }}</span>
            </div>
            <div class="num">
              <span v-if="item.subscriptionType == 0">{{ $t('common.每') }}{{ $t('common.年') }}</span>
              <span v-if="item.subscriptionType == 1">{{ $t('common.每') }}{{ $t('common.月') }}</span>
              <span v-if="item.subscriptionType == 2">{{ $t('common.每') }}{{ $t('common.季') }}</span>
              <span v-if="item.subscriptionType == 3">{{ $t('common.每') }}{{ $t('common.半年') }}</span>
            </div>
          </div>
        </div>
        <div class="pay-list">
          <div class="item" @click="payType = 0">
            <img src="~@/assets/common/22.png">
            <div class="span">{{ $t('common.微信') }}{{ $t('common.支付') }}</div>
            <img src="~@/assets/common/21.png" v-if="payType == 0">
            <img src="~@/assets/common/20.png" v-else>
          </div>
          <div class="item" @click="payType = 1">
            <img src="~@/assets/common/23.png">
            <div class="span">{{ $t('common.支付宝') }}{{ $t('common.支付') }}</div>
            <img src="~@/assets/common/21.png" v-if="payType == 1">
            <img src="~@/assets/common/20.png" v-else>
          </div>
        </div>
        <div class="btn-list">
          <div class="btn" @click="submitDy()">{{ $t('common.确认协议并支付') }}</div>
          <div class="btn1">{{ $t('common.订阅前请阅读') }}<span @click="onDy()">《{{ $t('common.订阅协议') }}》</span></div>
        </div>
        <div class="title">
          <div class="name">{{ $t('common.特权对比') }}</div>
        </div>
        <div class="table">
          <div class="th">
            <div class="td"></div>
            <div class="td">{{ $t('common.普通用户') }}</div>
            <div class="td">SVIP</div>
          </div>
          <div class="tr">
            <div class="td">{{ $t('common.订阅特权') }}</div>
            <div class="td">{{ $t('common.每条数据下载都需要付费') }}</div>
            <div class="td">{{ $t('common.订阅时间内可下载任何数据') }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t('common.订阅协议')" :visible.sync="visible1" width="1100px" :before-close="() => {this.visible1 = false}">
      <div class="info" v-html="html"></div>
    </el-dialog>
  </div>
</template>
  
<script>
import { configDetail, integralList, orderAdd, subscriptionList, orderEdit } from '@/utils/api'
import Bus from '@/utils/bus'
export default {
  name: "agreement",
  data() {
    return {
      type: 1,
      userIntegral: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).integral : 0,
      language: localStorage.getItem('language'),
      visible: false,
      visible1: false,
      title: "",
      html: '',

      //积分充值
      typeList: [{
        id: 1,
        integral: 10,
        price: 1
      },{
        id: 2,
        integral: 20,
        price: 2
      },{
        id: 3,
        integral: 50,
        price: 5
      },{
        id: 4,
        integral: 100,
        price: 10
      }],
      typeId: null,
      isCustom: false,  //是否自定义充值
      integral: null, //充值积分
      payType: 1, //支付方式
      price: 0, //支付金额

      //订阅
      typeList2: [{
        id: 1,
        unitPrice: 10.6,
        price: 128,
        tex: '每年',
      },{
        id: 2,
        unitPrice: 0,
        price: 128,
        tex: '每月',
      },{
        id: 3,
        unitPrice: 16,
        price: 48,
        tex: '每季',
      },{
        id: 4,
        unitPrice: 14.6,
        price: 88,
        tex: '每半年',
      }],
      typeId2: null,
    };
  },
  methods: {
    init(type) {
      let configKey = ''
      this.type = type
      if (type == 1) {
        this.title = this.$t('common.注册协议');
        if(this.language == 'en-US'){
          configKey = 'zcxyEn'
        }else{
          configKey = 'zcxy'
        }
      } else if (type == 2) {
        this.title = this.$t('common.隐私政策');
        if(this.language == 'en-US'){
          configKey = 'yszcEn'
        }else{
          configKey = 'yszc'
        }
      } else if (type == 3) {
        this.title = this.$t('common.免责声明');
        if(this.language == 'en-US'){
          configKey = 'mzsmEn'
        }else{
          configKey = 'mzsm'
        }
      } else if (type == 5) {
        this.title = this.$t('common.积分充值');
      } else if (type == 6) {
        this.title = this.$t('common.订阅');
      }
      this.visible = true;
      if(type == 1 || type == 2 || type == 3){
        configDetail({configKey}).then(res => {
          this.html = res.configValue
        })
      }
      if(type == 5){
        integralList().then(res => {
          this.typeList = res
        })
      }
      if(type == 6){
        subscriptionList().then(res => {
          this.typeList2 = res
        })
      }
    },
    onDy(){
      this.visible1 = true
      let configKey
      if(this.language == 'en-US'){
          configKey = 'dyxyEn'
        }else{
          configKey = 'dyxy'
        }
      configDetail({configKey}).then(res => {
        this.html = res.configValue
      })
    },
    onTypeItem(item){
      this.isCustom = false
      this.typeId = item.id
      this.integral = item.integralNum
      this.price = item.integralMoney
    },
    onCustom(){
      this.isCustom = !this.isCustom
      if(this.isCustom){
        this.integral = 0
        this.price = 0
        this.typeId = null
      }
    },

    //积分充值
    submitJf(){
      orderAdd({
        objId: this.typeId,
        objMoney: this.integral,
        payType: this.payType,
        payTypeMoney: this.isCustom ? 1 : 0
      }).then(res => {
        this.visible = false
        Bus.$emit("infoUpdates", true)  //临时的
        this.$message({
          message: res.message,
          type: 'success'
        })
        // if(this.payType == 0){
        //   // 微信返回的是一个地址，window.open在safari中会被阻止，这里就用window.location.href
        //   const url = JSON.parse(res).h5_url    // res是接口返回的数据需要转一下 
        //   window.location.href = url
        // }else if(this.payType == 1){
        //   // 支付宝返回的是表单，插入到页面中直接提交就会调起支付宝支付页面(放弃支付时会回到之前的页面，支付宝不提供放弃支付时的页面跳转)
        //   const divForm = document.getElementsByTagName('divform')
        //   if (divForm.length) {
        //     document.body.removeChild(divForm[0])
        //   }
        //   const div = document.createElement('divform')
        //   div.innerHTML = res // res就是支付宝返回给你的form
        //   document.body.appendChild(div)
        //   document.forms[0].submit()
        // }
      })
    },

    //订阅
    submitDy(){
      orderEdit({
        objId: this.typeId2,
        payType: this.payType
      }).then(res => {
        this.visible = false
        Bus.$emit("infoUpdates", true)  //临时的
        this.$message({
          message: res.message,
          type: 'success'
        })
        // if(this.payType == 0){
        //   // 微信返回的是一个地址，window.open在safari中会被阻止，这里就用window.location.href
        //   const url = JSON.parse(res).h5_url    // res是接口返回的数据需要转一下 
        //   window.location.href = url
        // }else if(this.payType == 1){
        //   // 支付宝返回的是表单，插入到页面中直接提交就会调起支付宝支付页面(放弃支付时会回到之前的页面，支付宝不提供放弃支付时的页面跳转)
        //   const divForm = document.getElementsByTagName('divform')
        //   if (divForm.length) {
        //     document.body.removeChild(divForm[0])
        //   }
        //   const div = document.createElement('divform')
        //   div.innerHTML = res // res就是支付宝返回给你的form
        //   document.body.appendChild(div)
        //   document.forms[0].submit()
        // }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding: 20px 30px !important;
  background: #F9F9F9;
  border-bottom: 1px solid #E2E2E2;
}
/deep/ .el-dialog__body{
  padding: 20px 10px !important;
}
.info{
  width: 100%;
  padding: 0 20px !important;
  height: 50vh;
  overflow-y: auto;
  font-size: 16px;
  color: #666666;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #E5E5E5;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0;
    background: #ffffff;
  }
}

.recharge{
  width: 100%;
  padding: 0 60px;
  .balance{
    font-size: 18px;
    color: #333333;
    display: flex;
    align-items: center;
    span{
      font-size: 22px;
      font-weight: bold;
    }
  }
  .type-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0;
    .item{
      width: 190px;
      height: 166px;
      border-radius: 6px;
      overflow: hidden;
      background: #F8F6FC;
      display: flex;
      flex-direction: column;
      margin-right: 60px;
      margin-bottom: 30px;
      border: 2px solid transparent;
      cursor: pointer;
      position: relative;
      &:nth-child(4n){
        margin-right: 0;
      }
      .icon{
        width: 44px;
        height: 44px;
        position: absolute;
        top: -2px;
        right: -2px;
        z-index: 1;
      }
      .tex{
        flex-grow: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        color: #333333;
      }
      .num{
        flex-shrink: 0;
        width: 100%;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: #4D0CF0;
        background: rgba(77, 12, 240, .1);
      }
    }
    .item-on{
      border-color: #4D0CF0;
    }
  }
  .custom{
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    cursor: pointer;
    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .input{
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    span{
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
  .price{
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
  }
  .pay-list{
    width: 100%;
    .item{
      width: 100%;
      height: 48px;
      border: 1px solid #EEEEEE;
      border-radius: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 20px;
      cursor: pointer;
      img{
        flex-shrink: 0;
        width: 22px;
        height: 22px;
      }
      .span{
        padding: 0 16px;
        flex-grow: 1;
        font-size: 16px;
        color: #333333;
      }
    }
  }
  .btn-list{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
    .btn{
      min-width: 283px;
      height: 55px;
      padding: 0 20px;
      border-radius: 4px;
      font-size: 20px;
      color: #ffffff;
      background: linear-gradient(90deg, #4508EE 0%, #701FF5 100%);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .btn1{
      margin-top: 20px;
      font-size: 16px;
      color: #C6C8CB;
      span{
        cursor: pointer;
      }
    }
  }
  .title{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .name{
      min-width: 120px;
      height: 40px;
      padding: 0 40px;
      background: url('~@/assets/common/24.png') no-repeat;
      background-size: 100% 10px;
      background-position-y: 15px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .table{
    width: 100%;
    background: url('~@/assets/common/25.png') no-repeat;
    background-size: 100% 100%;
    .th{
      width: 100%;
      display: flex;
      .td{
        height: 55px;
      }
    }
    .tr{
      width: 100%;
      display: flex;
      .td{
        height: 110px;
        font-weight: bold;
      }
    }
    .td{
      width: 33.33%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 0 20px;
      color: #333333;
      &:nth-child(3){
        color: #4D0CF0;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/agreement.vue